import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';
import { getToken } from 'src/utils/auth';
import { getAPI } from 'src/utils/api';
import Rows from './Rows';

const ColorIndex = () => {
  const [colors, setColors] = useState<any>(null);

  const getSetting = async () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      getAPI(`/master/get-reserve-color?token=${token}`)
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setColors(res.data);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  const checkObject = (object: any) => {
    return typeof object != 'undefined';
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell width={'200px'}>項目</TableCell>
            <TableCell>背景色</TableCell>
            <TableCell>フォントの色</TableCell>
            <TableCell>修正</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {colors &&
            checkObject(colors.nonops) &&
            colors.nonops.map((color: any, index: number) => (
              <Rows color={color} key={index} />
            ))}
          {colors &&
            checkObject(colors.mrns) &&
            colors.mrns.map((color: any, index: number) => (
              <Rows color={color} key={index} />
            ))}
          {colors &&
            checkObject(colors.ops) &&
            colors.ops.map((color: any, index: number) => (
              <Rows color={color} key={index} />
            ))}
          {colors &&
            checkObject(colors.payments) &&
            colors.payments.map((color: any, index: number) => (
              <Rows color={color} key={index} />
            ))}
          {colors &&
            checkObject(colors.vips) &&
            colors.vips.map((color: any, index: number) => (
              <Rows color={color} key={index} />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ColorIndex;
